// 7 баров по дням недели (пн-вс). Подсветка самого «дорогого» дня.

import { formatWithCurrency } from '../../lib/money';

type Bucket = {
  dow: number; // 0=Sun..6=Sat (как из Postgres EXTRACT)
  amountMinor: string;
  count: number;
};

type Props = {
  buckets: Bucket[];
  currency: string;
  color?: string;
};

const RU_DOW = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export function DayOfWeekChart({
  buckets,
  currency,
  color = 'var(--accent)',
}: Props): JSX.Element {
  // Перерасставляем: pg dow 0=Sun..6=Sat → ru 0=Mon..6=Sun.
  const order = [1, 2, 3, 4, 5, 6, 0]; // ru-индексы 0..6 → pg-dow
  const reordered = order.map((pgDow) =>
    buckets.find((b) => b.dow === pgDow) ?? { dow: pgDow, amountMinor: '0', count: 0 },
  );

  const values = reordered.map((b) => Number(BigInt(b.amountMinor) / 100n));
  const max = Math.max(...values, 1);
  const maxIdx = values.indexOf(max);

  return (
    <div className="dow-chart">
      <div className="dow-bars">
        {reordered.map((b, i) => {
          const v = values[i] ?? 0;
          const heightPct = max > 0 ? (v / max) * 100 : 0;
          const isPeak = i === maxIdx && v > 0;
          return (
            <div key={i} className="dow-col">
              <div className="dow-bar-wrap">
                <div
                  className="dow-bar"
                  style={{
                    height: `${heightPct}%`,
                    background: isPeak ? 'var(--accent)' : color,
                    opacity: isPeak ? 1 : 0.55,
                  }}
                  title={`${RU_DOW[i]}: ${formatWithCurrency(b.amountMinor, currency)} (${b.count} тр.)`}
                />
              </div>
              <div className="dow-label">{RU_DOW[i]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
